import _ from 'underscore';

import { MapperHelper } from '../../mappers/MapperHelper';
import { UserMapper } from '../../mappers/UserMapper';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { ICustomViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { ICustomView } from './ICustomView';
import { ICustomViewInfo } from './ICustomViewInfo';

export module CustomViewMapper {
  const M = MapperHelper;

  export function map(
    customViews: ICustomView[],
    sites: _.Dictionary<ISiteNameWithId>,
    usageInfoMaxValues: ICustomViewUsageInfo,
    users: _.Dictionary<IUser>,
  ): ICustomViewInfo[] {

    return _.map(customViews, (cv: ICustomView): ICustomViewInfo => {
      return {
        contentType:       'customView',
        failed:             cv.failed,
        id:                 cv.id,
        lastAccessedAt:     M.toDate(cv.lastAccessedAt),
        luid:               cv.luid,
        name:               cv.name,
        site:               sites[cv.siteId],
        owner:              UserMapper.mapOne(users[cv.ownerId]),
        updatedAt:          M.toDate(cv.updatedAt),
        urlId:              cv.urlId,
        usageInfo:          cv.usageInfo || <ICustomViewUsageInfo>{},
        usageInfoMaxValues: usageInfoMaxValues || <ICustomViewUsageInfo>{},
        viewId:             cv.viewId,
        viewName:           cv.viewName,
        workbookId:         cv.workbookId
      };
    });
  }
}
